var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.5L21 21.5M3 11.5C3 13.6217 3.84285 15.6566 5.34315 17.1569C6.84344 18.6571 8.87827 19.5 11 19.5C13.1217 19.5 15.1566 18.6571 16.6569 17.1569C18.1571 15.6566 19 13.6217 19 11.5C19 9.37827 18.1571 7.34344 16.6569 5.84315C15.1566 4.34285 13.1217 3.5 11 3.5C8.87827 3.5 6.84344 4.34285 5.34315 5.84315C3.84285 7.34344 3 9.37827 3 11.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.378fad1aca3e19f76ef808a7535c085d.svg";
export { ForwardRef as ReactComponent };